<template>
  <p :style="style">
    {{ name || '-' }}
  </p>
</template>

<script>
const style = {
  1: { fontWeight: 400 },
  2: { fontWeight: 600 },
  3: { fontWeight: 700 },
};

export default {
  name: 'AccountStatus',
  props: {
    id: Number,
    name: String,
  },
  computed: {
    style() {
      return {
        ...(style[this.id] || {}),
      };
    },
  },
};
</script>

<style>
</style>